import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=75b6ed65"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75b6ed65')) {
      api.createRecord('75b6ed65', component.options)
    } else {
      api.reload('75b6ed65', component.options)
    }
    module.hot.accept("./statistics.vue?vue&type=template&id=75b6ed65", function () {
      api.rerender('75b6ed65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/status/statistics.vue"
export default component.exports